import { Article, Tax } from '@thro-types/billing';

export const getTaxOptionsArray = (
  salesTaxes: Tax[],
  article?: Partial<Pick<Article, 'defaultTax'>>
) => {
  const taxArray = [article?.defaultTax, ...salesTaxes]
    .filter(tax => tax !== undefined && tax !== null)
    .filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
  return taxArray;
};
